/**
 * Where the model capability endpoints live.
 *
 * Every path carries the trailing slash the router declares, because FastAPI
 * 307-redirects a missing one before auth runs and the client would then
 * follow an unauthenticated redirect into a 401.
 *
 * Project scope is a path segment, never a query parameter: the RBAC surface
 * resolver reads the project id out of `request.path_params`, so a governance
 * read or write addressed any other way would be decided against the caller's
 * organisation-wide rank and silently ignore their project grant. `scoped()`
 * is the single place that choice is made.
 */

export const BASE = '/api/v1/model-capabilities'

/**
 * The org-global family, or the project family when a project is named. The
 * two are separate route rows with separate scope surfaces, so which one a
 * call lands on is the whole of what decides the caller's rank.
 */
export const scoped = (projectId?: string): string =>
  projectId ? `${BASE}/projects/${projectId}` : BASE
